"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FileParameterApi_logger, _FileParameterApi_parameter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFileParameterApi = exports.FileParameterApi = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const ParameterApi_1 = require("./ParameterApi");
class FileParameterApi extends ParameterApi_1.ParameterApi {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(parameter) {
        super(parameter);
        // #region Properties (2)
        _FileParameterApi_logger.set(this, viewer_shared_services_1.Logger.instance);
        _FileParameterApi_parameter.set(this, void 0);
        __classPrivateFieldSet(this, _FileParameterApi_parameter, parameter, "f");
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    getFilename(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _FileParameterApi_parameter, "f").getFilename(fileId);
        });
    }
    upload(v) {
        return __classPrivateFieldGet(this, _FileParameterApi_parameter, "f").upload(v);
    }
}
exports.FileParameterApi = FileParameterApi;
_FileParameterApi_logger = new WeakMap(), _FileParameterApi_parameter = new WeakMap();
const isFileParameterApi = (obj) => obj instanceof FileParameterApi;
exports.isFileParameterApi = isFileParameterApi;
//# sourceMappingURL=FileParameterApi.js.map